import React, { VFC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@dxb-web-ui-framework/design-system';
import { useOnToggleAuthFlowDrawer, useOnSetRequestNewRate, useOnSetAuthAction } from '../contexts';

const MandateRequestRateBtn: VFC<{ isLoading: boolean }> = ({ isLoading }) => {
  const { t } = useTranslation();
  const onToggleAuthFlowDrawer = useOnToggleAuthFlowDrawer();
  const onSetRequestRateFlag = useOnSetRequestNewRate();
  const setAuthAction = useOnSetAuthAction();

  const onClick = useCallback(() => {
    onSetRequestRateFlag(true);
    onToggleAuthFlowDrawer();
    setAuthAction('approve');
  }, [onToggleAuthFlowDrawer, onSetRequestRateFlag, setAuthAction]);

  return (
    <Button
      hasSkeleton={isLoading}
      title={t('authorizationsListPage.ApproveRejectFlow.Info.SpecialRate.Title')}
      onClick={onClick}>
      {t('authorizationsListPage.ApproveRejectFlow.Info.SpecialRate.Title')}
    </Button>
  );
};

export { MandateRequestRateBtn };
